import { getEnvVar } from './env';
import { getItem, LOCALSTORAGE_KEYS } from './localStorage';

export function getOrgStatus(): {
  baseOrganizationId: number | undefined;
  currentOrganizationId: number | undefined;
  hasChangedOrg: boolean;
} {
  const baseOrganizationId = getEnvVar('BASE_ORGANIZATION_ID');
  const currentOrganizationId =
    getItem(LOCALSTORAGE_KEYS.CURRENT_ORGANIZATION_ID) || 0;

  return {
    baseOrganizationId,
    currentOrganizationId,
    hasChangedOrg: baseOrganizationId !== currentOrganizationId,
  };
}
